<template>
  <v-row>
    <v-col>
      <v-card>
        <general-error v-if="!!generalError" />
        <v-card-text>
          <v-data-table
              :headers="headers1"
              :items="orders"
              :items-per-page="itemsPerPage"
              item-key="orderId"
              class="elevation-1 orders"
              disable-sort-by
              single-expand
              show-expand
              :loading="isLoading"
              :locale="systemLocale">
            <template v-slot:progress>
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.sessionNumber="{ item }">
              {{ item.sessionNumber }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationName="{ item }">
              <route-link-with-tip
                  v-if="isAdmin"
                  :text="item.organizationName"
                  :tip="$t('Просмотр организации')"
                  :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
              <span v-else>
                {{ item.organizationName }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.userName="{ item }">
              <route-link-with-tip
                  v-if="isAdmin"
                  :text="item.userName"
                  :tip="$t('Просмотр пользователя')"
                  :to="{ path: `${urlRootPath}/user/${item.userId}` }" />
              <span v-else>
                {{ item.userName }}
              </span>
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.orderDate="{ item }">
              {{ item.orderDate
                ? $moment(item.orderDate).format('DD.MM.YYYY HH:mm:ss')
                : null }}
            </template>

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.isWinner="{ item }">
              <icon-tip
                  v-if="item.isWinner"
                  icon="done"
                  icon-color="green darken-2" />
              <!-- <v-checkbox
                  v-model="item.isWinner"
                  dense
                  :height="10"
                  disabled /> -->
            </template>
            <template v-slot:expanded-item="{ headers, item } ">
              <td :colspan="headers.length">
                <v-row class="py-2">
                  <v-col :cols="item.additionalInfo || item.fileId ? 7 : 12">
                    <v-row class="my-2">
                      <text-view
                          v-if="item.deliveryBasisDescription"
                          align-self="center"
                          :label="$t('Порт/место назначения')"
                          :display="item.deliveryBasisDescription" />
                    </v-row>
                    <v-divider />
                    <v-data-table
                        :key="item.orderId"
                        :headers="headers2"
                        :items="item.premiums || []"
                        :items-per-page="nestedItemsPerPage"
                        item-key="positionId"
                        class="premiums"
                        disable-sort-by
                        dense
                        hide-default-footer
                        :locale="systemLocale">
                      <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                      <template v-slot:item.positionDescription="{ item }">
                        {{ item.positionDescription }}
                      </template>
                      <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                      <template v-slot:item.premium="{ item }">
                        {{ item.premium }}
                      </template>
                      <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
                      <template v-slot:item.premiumWithDelivery="{ item }">
                        {{ item.premiumWithDelivery }}
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col v-if="item.additionalInfo || item.fileId" cols="5">
                    <v-row class="px-2 py-2 pb-0 mb-0">
                      <v-col class="pb-0 mb-0">
                        <v-icon>
                          link
                        </v-icon>
                        {{ $t('Дополнительно') }}
                      </v-col>
                    </v-row>
                    <v-row v-if="item.additionalInfo" class="px-2 pt-2 pb-0 mb-0">
                      <v-col class="pb-0 mb-0">
                        <v-textarea
                            :value="item.additionalInfo"
                            readonly
                            solo
                            rows="2"
                            dense />
                      </v-col>
                    </v-row>
                    <v-row
                        v-if="item.fileId"
                        class="px-2 pb-2 pt-0 mt-0"
                        align="center">
                      <text-view
                          :cols="10"
                          align-self="center"
                          :label="$t('Прикрепленные документы')"
                          :display="' '" />
                      <v-col cols="2" align-self="center">
                        <btn-icon-tip
                            icon="get_app"
                            :tip="$t('Скачать документ')"
                            @click="getBusinessFile(item.fileId)" />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
          <v-row>
            <v-col class="text-left">
              <text-view
                  :display="tradeResult"
                  :label="$t('Итог торгов')" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="canEditResults">
          <v-btn
              v-if="canUploadOfferRegistry && !isLoading"
              id="uploadReestrBtn"
              v-test="{ btn: 'reestr' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="attachLotOffersRegistry">
            {{ $t('Прикрепить реестр предложений') }}
          </v-btn>
          <v-btn
              v-if="canCreateNoOrderResult && !isLoading"
              id="createNoOrdersBtn"
              key="createNoOrders"
              v-test="{ btn: 'createNoOrders' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="openConfirmDialog">
            {{ $t('Подвести итоги (нет ценовых предложений)') }}
          </v-btn>
          <v-btn
              v-if="canSetFailedResult"
              id="setFailedBtn"
              key="setFailedBtn"
              v-test="{ btn: 'setFailedBtn' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="openConfirmForFailedResultDialog">
            {{ $t('Изменить итоги (торги не состоялись)') }}
          </v-btn>
          <v-btn
              v-if="canCreateResult"
              id="updateBtn"
              key="update"
              v-test="{ btn: 'update' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="goToWinnerSelection">
            {{ $t('Подвести итоги') }}
          </v-btn>
          <confirm-dialog
              v-if="confirmDialog.show"
              :dialog-prop="confirmDialog"
              @close="closeDialog('confirmDialog')" />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
  .orders::v-deep td:nth-child(3) {
   word-break: break-all;
   max-width: 450px;
  }
  .orders::v-deep td:nth-child(1) {
    min-width: 200px;
  }
  .premiums::v-deep td:nth-child(1) {
    word-break: break-all;
    max-width: 550px;
  }
  .premiums::v-deep td:nth-child(2) {
    min-width: 150px;
  }
</style>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import { TRADE_RESULT_TYPE_ENUM } from '@/constants/enums'
  import {
    LOT_STATUSES, TRADE_RESULT_TYPES,
    DOCUMENT_TYPES, PREMIUM_TYPES
  } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_DOCUMENTATION, LOT_WINNERS_MANAGEMENT, LOT_DOCUMENT_GENERATOR } from '@/constants/store.js'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      GeneralError,
      ConfirmDialog,
      TextView,
      BtnIconTip,
      RouteLinkWithTip,
      IconTip
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        LOT_STATUSES,
        isLoading: false,
        itemsPerPage: 10,
        nestedItemsPerPage: -1,
        confirmDialog: {
          show: false,
          text: null,
          callback: null,
          warning: true
        }
      }
    },
    computed: {
      ...mapState(LOT_DOCUMENTATION.NAMESPACE, {
        tradeProcessDocumentation: state => (state[LOT_DOCUMENTATION.STATE.TRADE_PROCESS_DOCUMENTATION] || [])
      }),
      ...mapState(LOT_WINNERS_MANAGEMENT.NAMESPACE, {
        winnersInfo: state => (state[LOT_WINNERS_MANAGEMENT.STATE.WINNER_SELECTION_LIST] || {})
      }),
      isFixPremium () {
        return this.lot.premiumType === PREMIUM_TYPES.FIX
      },
      canSetFailedResult () {
        return this.isMainAdmin &&
          this.hasResult &&
          this.winnersInfo.tradeResultType === TRADE_RESULT_TYPES.WINNER_SELECTED
      },
      canCreateNoOrderResult () {
        return !this.hasResult &&
          !this.hasOrder &&
          this.canEditResults &&
          this.lot.lotStatus === LOT_STATUSES.REGISTERED
      },
      canCreateResult () {
        return this.hasOrder &&
          !this.hasResult &&
          this.canEditResults &&
          this.lot.lotStatus === LOT_STATUSES.REGISTERED
      },
      canEditResults () {
        return (this.isAdmin || this.isLotOwner(this.lot)) &&
          !!this.lot.lotStatus
      },
      canUploadOfferRegistry () {
        return !this.hasUploadOfferRegistry &&
          (this.isAdmin || (this.isLotOwner(this.lot) && !this.hasResult)) &&
          !this.isLoading // admin - после подведения итогов, организатор - до.
      },
      headers1 () {
        let headers = [
          { text: this.$t('№ Сессии'), sortable: false, value: 'sessionNumber' },
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Пользователь'), sortable: false, value: 'userName' },
          { text: this.$t('Время выставления'), sortable: false, value: 'orderDate' },
          { text: this.$t('Победитель'), sortable: false, value: 'isWinner' },
          { text: '', value: 'data-table-expand' }
        ]
        if (!this.isAdmin) {
          headers = headers.filter(h => h.value !== 'userName' && h.value !== 'sessionNumber')
        }
        return headers
      },
      headers2 () {
        return [
          { text: this.$t('Наименование позиции'), sortable: false, value: 'positionDescription' },
          { text: this.premiumHeader, sortable: false, value: this.showDeliveryBasises ? 'premiumWithDelivery' : 'premium' }
        ]
      },
      showDeliveryBasises () {
        return this.lot.hasBasises
      },
      premiumHeader () {
        const premiumLabel = this.showDeliveryBasises
          ? this.isFixPremium
            ? 'Значение цены в базисе поставки'
            : 'Значение дифференциала в базисе поставки'
          : this.isFixPremium
            ? 'Цена за единицу в валюте Контракта'
            : 'Значение дифференциала'

        return this.$t(premiumLabel)
      },
      orders () {
        const orders = this.winnersInfo.orders || []
        return orders
      },
      hasResult () {
        const result = this.winnersInfo.tradeResultType
        return !!result && result !== TRADE_RESULT_TYPES.UNSET
      },
      hasOrder () {
        return this.orders.length > 0
      },
      tradeResult () {
        const result = this.winnersInfo.tradeResultType
        return this.$t(result
          ? TRADE_RESULT_TYPE_ENUM[result]
          : TRADE_RESULT_TYPE_ENUM[TRADE_RESULT_TYPES.UNSET])
      },
      hasWinnerSelected () {
        const result = this.winnersInfo.tradeResultType
        return !!result && result === TRADE_RESULT_TYPES.WINNER_SELECTED
      },
      hasUploadOfferRegistry () {
        const mainDocTypesList = [
          DOCUMENT_TYPES.REGISTRY
        ]
        return this.hasUploadDocuments(mainDocTypesList)
      },
      hasUploadDocuments () {
        return (mainDocTypesList) => {
          const lotDocumentation = this.tradeProcessDocumentation
          return lotDocumentation.some(d => mainDocTypesList.includes(d.documentType))
        }
      }
    },
    watch: {
      lot: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal.lotId) {
            this.initialize()
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_DOCUMENTATION.NAMESPACE, {
        getTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.GET_TRADE_PROCESS_DOCUMENTATION,
        clearTradeProcessDocumentationAction: LOT_DOCUMENTATION.ACTIONS.CLEAR_TRADE_PROCESS_DOCUMENTATION
      }),
      ...mapActions(LOT_WINNERS_MANAGEMENT.NAMESPACE, {
        getWinnerSelectionListAction: LOT_WINNERS_MANAGEMENT.ACTIONS.GET_WINNER_SELECTION_LIST,
        selectWinnersAction: LOT_WINNERS_MANAGEMENT.ACTIONS.SELECT_WINNERS,
        updateWinnersAction: LOT_WINNERS_MANAGEMENT.ACTIONS.UPDATE_WINNERS,
        clearWinnerSelectionListAction: LOT_WINNERS_MANAGEMENT.ACTIONS.CLEAR_WINNER_SELECTION_LIST
      }),
      ...mapActions(LOT_DOCUMENT_GENERATOR.NAMESPACE, {
        getLotProtocolAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_PROTOCOL,
        attachLotProtocolAction: LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_PROTOCOL,
        getLotOffersRegistryAction: LOT_DOCUMENT_GENERATOR.ACTIONS.GET_LOT_OFFERS_REGISTRY,
        attachLotOffersRegistryAction: LOT_DOCUMENT_GENERATOR.ACTIONS.ATTACH_LOT_OFFERS_REGISTRY
      }),
      initialize: async function () {
        this.isLoading = true
        try {
          await Promise.all([
            this.getTradeProcessDocumentationAction({
              lotId: this.lot.lotId,
              lotType: this.lot.lotType
            }),
            this.getWinnerSelectionListAction({
              lotId: this.lot.lotId,
              lotType: this.lot.lotType
            })
          ])

          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearWinnerSelectionListAction(),
            this.clearTradeProcessDocumentationAction()
          ])
      },
      getLotProtocol: async function () {
        try {
          this.isLoading = true
          await this.getLotProtocolAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getLotOffersRegistry: async function () {
        try {
          this.isLoading = true
          await this.getLotOffersRegistryAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      attachLotOffersRegistry: async function () {
        try {
          this.isLoading = true
          await this.attachLotOffersRegistryAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
          await this.initialize()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      setNoPremiumOrdersResult: async function () {
        await this.setTradeResult(this.selectWinnersAction)
      },
      setFailedResult: async function () {
        await this.setTradeResult(this.updateWinnersAction)
      },
      setTradeResult: async function (methodName) {
        const model = {
          lotId: this.lot.lotId,
          lotType: this.lot.lotType,
          result: {
            tradeResultType: TRADE_RESULT_TYPES.FAILED
          }
        }
        try {
          this.isLoading = true
          await methodName(model)
          await this.getWinnerSelectionListAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      goToWinnerSelection: function () {
        this.goToRoute(`${this.urlRootPath}/lot/${this.lot.lotType}/${this.lot.lotId}/winners`)
      },
      openConfirmDialog: function () {
        this.confirmDialog.text = this.$t('После подведения итогов создание новых торговых сессий по торговой процедуре будет недоступно. Торговая процедура переместится в архив завершенных торговых процедур. Продолжить?')
        this.confirmDialog.callback = this.setNoPremiumOrdersResult
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      openConfirmForFailedResultDialog: function () {
        this.confirmDialog.text = this.$t('Итог по торговой процедуре будет изменен на "Торги не состоялись". Продолжить?')
        this.confirmDialog.callback = this.setFailedResult
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      }
    }
  }
</script>
